import {genqlBuilder} from "@/core/graphql/genql/builder"

import {MutationGenqlSelection, FortuneSpinResult} from "../schema"

export type MutationFortuneSpinVars = {}

export function fortuneSpinMutation(mutation: MutationGenqlSelection['fortune_spin'] | null) {            
    return {
      build: (variables: MutationFortuneSpinVars) => genqlBuilder.build(mutation ? {fortune_spin: mutation} : {__scalar: true}, {fortune_spin: variables}),  
      mutate: (variables: MutationFortuneSpinVars) => ({} as Promise<FortuneSpinResult>),
      _variables: {} as MutationFortuneSpinVars,
      _result: {} as FortuneSpinResult,
    }
}

export type MutationFortuneSpin = {
  builder: (variables: MutationFortuneSpinVars) => MutationGenqlSelection,
  selection: MutationGenqlSelection['fortune_spin'],
  variables: MutationFortuneSpinVars,
  result: FortuneSpinResult
}

export default fortuneSpinMutation